import type { ComponentProps } from 'react'
import React from 'react'

import ImageGallery from 'LuxKit/Carousel/ImageGallery'
import { useScreenSizeUp } from 'hooks/useScreenSize'

type InheritedImageGalleryProps = Pick<
  ComponentProps<typeof ImageGallery>,
  'onImageChange' | 'topRight' | 'imageParams' | 'className' | 'onOpenLightbox' | 'disableLightbox'
>

interface Props extends InheritedImageGalleryProps {
  room: App.Property.Room | App.PackageRoomType | App.BedbankPackage
}

function OfferPageRoomGallery(props: Props) {
  const {
    room,
    ...rest
  } = props

  const isDesktop = useScreenSizeUp('desktop')
  const useThumbnailLightbox = isDesktop
  if (!room.images) return null

  return <ImageGallery
    {...rest}
    images={room.images}
    useThumbnailLightbox={useThumbnailLightbox}
    size="small"
    showImageTitles={false}
  />
}

export default OfferPageRoomGallery
